import React from 'react'
import Switch from 'react-switch'

export default ({ checked, onChange }) => {
  return <Switch checked={checked} onColor={'#46b8da'} onChange={onChange} />
}
